/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Invite_Code_RequiredInputs */

const en_common_sign_invite_code_required = /** @type {(inputs: Common_Sign_Invite_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code is required`)
};

/**
* | output |
* | --- |
* | "Invite code is required" |
*
* @param {Common_Sign_Invite_Code_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_invite_code_required = /** @type {((inputs?: Common_Sign_Invite_Code_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Invite_Code_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_invite_code_required(inputs)
});
export { common_sign_invite_code_required as "common.sign.invite_code_required" }